export const iconDefaultProps = {
	size: 16,
	color: '#718096',
	strokeWidth: '3px',
};
